import Vue from "vue";
import { vueLogger } from "@/compose";

Vue.use(vueLogger);

window.addEventListener("error", vueLogger.errorListener.bind(vueLogger));
